let installed = false;

/**
 * Guard against the white-screen crash that browser auto-translation (Google
 * Translate, in-app browser translators) triggers in React apps: the translator
 * swaps text nodes out from under React, so React's next removeChild /
 * insertBefore targets a node that is no longer where it expects it, and the
 * browser throws "NotFoundError: ... is not a child of this node", unmounting
 * the tree. We make those two ops a no-op (returning the node) when the node has
 * moved, instead of throwing. Mitigation for facebook/react#11538. Idempotent.
 */
export function installDomTranslateGuard() {
  if (installed) return;
  if (typeof Node !== 'function' || !Node.prototype) return;
  installed = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
